export default __webpack_public_path__ + "static/IllustImg02-01-be2ec591652bc3c056dba8ea0df1bf27.png";